import React from 'react';
import { Button, Form, Input, Row, Col } from 'antd';

const { TextArea } = Input;

const NotesForm = ({ form, id, closeModal, approveLicense, rejectLicense }) => {
  const { getFieldDecorator } = form;

  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 13 }
  };

  const handleApprove = e => {
    e.preventDefault();

    const data = form.getFieldsValue();

    approveLicense({ ID: id, ...data });

    closeModal();
  };

  const handleReject = e => {
    e.preventDefault();

    const data = form.getFieldsValue();

    rejectLicense({ ID: id, ...data });

    closeModal();
  };

  return (
    <Form {...formItemLayout} colon={false}>
      <Form.Item label="Notes">
        {getFieldDecorator('Notes', {
          rules: [
            {
              max: 120,
              message: 'The number of letters should be less than 120'
            }
          ]
        })(
          <TextArea
            autosize={true}
            placeholder="Please input some notes for approval or rejection (optional)"
          />
        )}
      </Form.Item>

      <Form.Item wrapperCol={{ span: 8, offset: 8 }}>
        <Row type="flex" justify="center" gutter={8}>
          <Col span={12}>
            <Button type="primary" block onClick={handleApprove}>
              Approve
            </Button>
          </Col>
          <Col span={12}>
            <Button type="danger" block onClick={handleReject}>
              Reject
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};

const NotesFormWrap = Form.create({ name: 'request_notes' })(NotesForm);

export default NotesFormWrap;
